import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar1.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
  AiFillMail
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
               <span className="purple"> INTRODUÇÃO </span> 
            </h1>
            <p className="home-about-body">
            Desde muito cedo, me apaixonei por programação e desde então busco evoluir diariamente.       
              <br />
              <br />Tenho grande habilidade em linguagens como
              <i>
                <b className="purple"> Javascript e Python. </b>
              </i>
              <br />sendo estas minhas principais áreas de conhecimento.
              <br />
              Minhas principais áreas de interesse são &nbsp;
              <i>
                <b className="purple">Desenvolvimento WEB </b> e
                também assuntos relacionados a {" "}
                <b className="purple">
                  Criação e Planejamento de Softwares.
                </b>
              </i>
              <br />
              <br />
              Sempre que possível, Eu aplico minha paixão por desenvolver em tecnologias com 
              <b className="purple"> Node.js</b> e
              <i>
                <b className="purple">
                  {" "}
                  Bibliotecas Modernas Javascript e Frameworks
                </b>
              </i>
              &nbsp; como
              <i>
                <b className="purple"> React.js</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg}  className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>MINHAS REDES</h1>
            <p>
              Seja livre para se <span className="purple">conectar </span>comigo
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/luizassano"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:luizassano2002@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillMail />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/luiz-augusto-assano/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/luiz_assano/?hl=pt-br"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
